import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Product } from '../_models/product';
import { environment } from '../../environments/environment';
import { ProductService } from '../_services/product.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ProductContent } from '../_models/product-content';

@Component({
  selector: 'app-product-add',
  templateUrl: './product-add.component.html',
  styleUrls: ['./product-add.component.css'],
})
export class ProductAddComponent implements OnInit {
  public isModified = false;
  public newProductContent = new ProductContent();
  public product: Product;
  public showAddContents = true;

  constructor(public productService: ProductService, private location: Location, public snackBar: MatSnackBar) {}

  public back(): void {
    this.location.back();
  }

  public dataChanged(): void {
    this.isModified = true;
  }

  public getImageUrl(): string {
    return environment.imageUrl;
  }

  public ngOnInit(): void {
    this.product = new Product();
  }

  public save(): void {
    this.productService
      .addProduct(this.product)
      .then((res) => {
        this.showSuccessMessage('Product was added successfully!');
      })
      .catch((err) => {
        console.error(err);
        this.showErrorMessage('Sorry, your request cannot be process at the moment!');
      });
  }

  public showErrorMessage(message): void {
    this.snackBar.open(message, 'Error', {
      duration: 2000,
    });
  }

  public showSuccessMessage(message): void {
    this.snackBar.open(message, 'Success', {
      duration: 2000,
    });
  }
}
